import React, { Component } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import { push } from 'react-router-redux'

// External
import { Table, TableCell, TableHeader, TableLoading, Button, Modal, Pagination, RoundedTabs } from 'advenio-components'

// Custom
import {Container, TableContainer, HeaderContainer, CellContainer, ModalContainer, PaginationContainer} from './video-styled'
import {videosColumns, tabs, actions} from './contants'
import DetailVideos from './DetailVideos'
import DeleteCenterVideos from './DeleteCenterVideos'
import {Toaster as Toast} from './components'
import {
    getCentersVideos as getCentersVideosService,
    sendCenterVideos as sendCenterVideosService,
    deleteCenterVideos as deleteCenterVideosService
} from './video-generator.service'

class VideoList extends Component {
    constructor(props) {
        super(props)

        this.state = {
            videoList: [],
            isLoaded: true,
            isOpened: false,
            videoCenterSelected: null,
            pageSelected: 1,
            elementsPerPage: 15,
            totalElements: 0,
            action: null,
            isActive: false,
            error: false
        }
    }

    componentDidMount() {
        this.getCentersVideos(1);
    }

    goTo = (e) => this.props.goTo(e.currentTarget.id);

    getCentersVideos = (page) => {
        this.setState({isLoaded: true});
        getCentersVideosService(page).then(
            (result) => {
                if(result){                    
                    const data = result.data;
                    const pagination = result.meta;
                    this.setState({
                        videoList: data,
                        totalElements: pagination.total,
                        isLoaded: false,
                        videoCenterSelected: null,
                    });
                }
            },
            (error) => this.activateToaster('Ha ocurrido un error', true)
        )
    }

    activateToaster = (msg, error = false) =>{
        this.setState({ error: error, isActive: true, msg: msg }, () => {
            setTimeout(() => {
                this.setState({ isActive: false, error: false });
            }, 3000);
        });
    }

    sendVideos = (id) => {
        sendCenterVideosService(id).then(
            (response) => {
                if(response){                    
                    this.activateToaster(response.message)
                    this.getCentersVideos(1)
                }
            },
            (error) => {
                this.activateToaster('Ha ocurrido un error', true);
                this.getCentersVideos(1)
            }
        )
    }

    handleClickAction = (row = null, action) => () => {
        this.setState({action: action});
        switch (action) {
            case actions.show:
                this.setState({
                    videoCenterSelected: row,
                    isOpened: true
                })
                break;
            case actions.send:
                this.setState({
                    isLoaded: true,             
                    pageSelected: 1,
                    elementsPerPage: 15,
                    totalElements: 0,
                    videoList: [],
                    videoCenterSelected: row
                });
                this.sendVideos(row.id);
                break;
            case actions.delete:
                this.setState({
                    videoCenterSelected: row,
                    isOpened: true
                })
                break;
        }
    }

    handleCloseModal = () => {
        this.setState({ isOpened: false, videoCenterSelected: null, action: null })
    }

    handleClickPage = page => {
        this.setState({pageSelected: page});
        this.getCentersVideos(page);
    }

    handleClickConfirmDelete = () => {
        this.setState({
            isOpened: false, 
            isLoaded: true,             
            pageSelected: 1,
            elementsPerPage: 15,
            totalElements: 0,
            videoList: []
        })

        deleteCenterVideosService(this.state.videoCenterSelected.id).then(
            (resp) => {
                this.activateToaster(resp.message)
                this.getCentersVideos(1)
            },
            (error) => {
                this.activateToaster('Ha ocurrido un error', true);
                this.getCentersVideos(1)
            }
        )
    }


    render(){

        return (
            <Container>
                <TableContainer>
                    <HeaderContainer>
                        <RoundedTabs selectedTab="/videos" tabs={tabs} onClick={this.goTo}/>
                    </HeaderContainer>

                    <PaginationContainer>
                        <Pagination
                            totalElements={this.state.totalElements}
                            elementsPerPage={this.state.elementsPerPage}
                            onPageClick={this.handleClickPage}
                            pageSelected={this.state.pageSelected}
                        />
                    </PaginationContainer>

                    {this.state.isLoaded ?
                        <TableLoading
                            roundedCorners
                            columns={videosColumns}
                            rows={15}
                        />
                    :
                        <Table
                            data={this.state.videoList}
                            columns={[
                                {
                                    Header: () => <TableHeader title="Centro" center blue />,
                                    accessor: 'center_name',
                                    Cell: ({ value }) => <CellContainer>{value}</CellContainer>,
                                },
                                {
                                    Header: () => <TableHeader title="Description" center blue />,
                                    accessor: 'description',
                                    Cell: ({ value }) => <CellContainer>{value}</CellContainer>,
                                },
                                {
                                    Header: () => <TableHeader title="Status" center blue />,
                                    accessor: 'status_name',
                                    Cell: ({ value }) => <CellContainer>{value}</CellContainer>,
                                },
                                {
                                    id: '4',
                                    Header: () => <TableHeader title="Acciones" center blue />,
                                    accessor: ({ id, center_name, description, status, detail}) => ({ id, center_name, description, status, detail }),
                                    Cell: ({  value }) => <TableCell center>
                                        <Button success small onClick={this.handleClickAction(value, actions.show)}>
                                            <span id={value.id}>Ver</span>
                                        </Button>
                                        <Button disabled={Boolean(value.status !== 2)} small primary onClick={this.handleClickAction(value, actions.send)}>
                                            <span id={value.id}>Enviar</span>
                                        </Button>
                                        <Button disabled={Boolean(value.status !== 2)} danger small onClick={this.handleClickAction(value, actions.delete)}>
                                            <span id={value.id}>Borrar</span>
                                        </Button>
                                    </TableCell>,
                                },
                            ]}
                        />
                    }
                </TableContainer>
                <Modal
                    isOpened={this.state.isOpened}
                    onClose={this.handleCloseModal}
                    headerTitle="Detalle"
                >
                    <ModalContainer>
                        {
                            this.state.action === actions.show
                            ?   <DetailVideos data={this.state.videoCenterSelected.detail} showWarning={this.state.videoCenterSelected.status > 1}/>
                            :   <DeleteCenterVideos {...this.state.videoCenterSelected} 
                                    onClickConfirm={this.handleClickConfirmDelete}
                                    onClickCancel={this.handleCloseModal}
                                />
                        }
                    </ModalContainer>
                </Modal>
                <Toast {...this.state}/>
            </Container>
        )
    }
}

const mapStateToProps = state => ({
})

const mapDispatchToProps = dispatch => ({
    goTo: path => dispatch(push(path)),
})
  
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(VideoList))


// WEBPACK FOOTER //
// ./src/Containers/VideoGenerator/VideoList.jsx